module.exports = __webpack_public_path__ + "fonts/montserrat-extralightitalic-webfont.fac0447.woff";